import { render, staticRenderFns } from "./settlementsubject.vue?vue&type=template&id=5471ee78&scoped=true&"
import script from "./settlementsubject.vue?vue&type=script&lang=js&"
export * from "./settlementsubject.vue?vue&type=script&lang=js&"
import style0 from "./settlementsubject.vue?vue&type=style&index=0&id=5471ee78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471ee78",
  null
  
)

export default component.exports